import axios from 'axios';
import { apiServerHost } from '../../../common/APIServerSettings';
import { DEV_API_FLAG } from '../../../common/API';

const createEntity_0 = (callBack, errorCallBack, topicId, type=0, name, language, synonymEntities, entitySynonyms_origin) => {
  const params = new URLSearchParams();
  params.append("topicID", topicId);
  params.append("entityName", name);
  params.append("entityValue", synonymEntities);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  
  const temp_params = {
    topicID : topicId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entityValue : synonymEntities,
  }
  const stringify_params = JSON.stringify(temp_params);
  
  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}create/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response, {
      type : type,
      entityName : name,
      entityLanguage : language,
      entityValue : entitySynonyms_origin,
    });
  })
}

const createEntity_1 = (callBack, errorCallBack, topicId, type=1, name, language, regex_value) => {
  const params = new URLSearchParams();
  params.append("topicID", topicId);
  params.append("entityName", name);
  params.append("entityValue", regex_value);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  
  const temp_params = {
    topicID : topicId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entityValue : [regex_value],
  }
  const stringify_params = JSON.stringify(temp_params);
  
  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}create/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response, {
      type : type,
      entityName : name,
      entityLanguage : language,
      entityValue : regex_value,
    });
  })
}

const createEntity_2 = (callBack, errorCallBack, topicId, type=2, name, language, regex_value, entityFunction) => {
  const params = new URLSearchParams();
  params.append("topicID", topicId);
  params.append("entityName", name);
  params.append("entityValue", regex_value);
  params.append("entityType", type);
  params.append("entityLanguage", language);
  params.append("entityFunction", entityFunction);
  
  const temp_params = {
    topicID : topicId,
    entityType : type,
    entityName : name,
    entityLanguage : language,
    entityValue : [regex_value],
    entityFunction : entityFunction,
  }
  const stringify_params = JSON.stringify(temp_params);
  
  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}create/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response, {
      type : type,
      entityName : name,
      entityLanguage : language,
      entityValue : regex_value,
      entityFunction : entityFunction,
    });
  })
}

const createEntity_3 = (callBack, errorCallBack, topicId, type=3, name, language, memberEntities) => {
  let memberEntities_toParam = memberEntities.map( memberEntity => {
    if (memberEntity.type === -1) {
      return {
        val : memberEntity.value,
        type : -1,
      }
    }
    return {
      id : memberEntity.id,
      type : memberEntity.type,
    }
  })
  const params = new URLSearchParams();
  params.append("topicID", topicId);
  params.append("entityType", type);
  params.append("entityName", name);
  params.append("entityLanguage", language);
  params.append("entities", memberEntities);
  
  memberEntities_toParam = JSON.stringify(memberEntities_toParam).replace("\"", "\\\"");
  memberEntities_toParam = memberEntities_toParam.slice(0,2) + memberEntities_toParam.slice(3,);
  
  const temp_params = {
    topicID : topicId,
    entityType : type,
    entityName : name,
    entityValue : null,
    entityLanguage : language,
    entities : memberEntities_toParam,
  }
  const stringify_params = JSON.stringify(temp_params);
  
  axios.post(apiServerHost + `/manage/topic/builder/${DEV_API_FLAG ? 'dev/' : ''}create/entity`, stringify_params, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    //'Content-Type': 'multipart/form-data'
    // 'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
  .catch(errorCallBack)
  .then( response => {
    callBack(response, {
      type : type,
      entityName : name,
      entityLanguage : language,
      entities : memberEntities,
    });
  })

  // axios({
  //   method: 'post',
  //   url: apiServerHost + "/manage/topic/builder/create/entity",
  //   data: params,
  //   headers: { 'content-type': 'application/json' },
  // })
  // .catch(errorCallBack)
  // .then( response => {
  //   callBack(response, {
  //     type : type,
  //     entityName : name,
  //     entityLanguage : language,
  //     memberEntities : memberEntities,
  //   });
  // })
}

export {createEntity_0};
export {createEntity_1};
export {createEntity_2};
export {createEntity_3};